import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

export function useHeatmap(siteId: string, url: string, range: '24h' | '7d' | '30d') {
  return useQuery({
    queryKey: ['heatmap', siteId, url, range],
    queryFn: () => api.sites.heatmap(siteId, url, range),
    enabled: Boolean(siteId && url),
  });
}
